var heading_default = {
  "fontElementMap": "L4kyf",
  "elementSpacing": "_9j-5z",
  "headerOne": "bRSWx _9j-5z",
  "headerTwo": "oNqci _9j-5z",
  "headerThree": "SLBiB _9j-5z",
  "headerFour": "fOZ9y _9j-5z",
  "headerFive": "bD4A0 _9j-5z",
  "headerSix": "JcCsG _9j-5z",
  "child": "d2Cmp"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
